export function isRedirectTrigger(trigger) {
    return trigger.type === 'redirect';
}
